import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import {
  TaskAssignmentContent,
  TaskAssignmentListSearchCriteria,
  TaskAssignmentResponse
} from '../../models/task-assignment.model';
import { TaskAssignmentActionType, TaskAssignmentActions } from '../actions/task-assignment.actions';
import { BaseState } from '../state/base.state';

export interface TaskAssignmentState extends EntityState<TaskAssignmentContent>, BaseState {
  selected: TaskAssignmentResponse;
  criteriaObject: TaskAssignmentListSearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
  isDeleteSuccess: boolean;
}

export const adapter: EntityAdapter<TaskAssignmentContent> = createEntityAdapter<TaskAssignmentContent>();

export const initialTaskAssignmentResponseState: TaskAssignmentState = adapter.getInitialState({
  selected: null,
  criteriaObject: {
    page: 0,
    size: 20
  },
  totalElements: null,
  totalPages: 20,
  auditLogs: null,
  isDeleteSuccess: null
});

export function taskAssignmentReducers(
  state = initialTaskAssignmentResponseState,
  action: TaskAssignmentActions
): TaskAssignmentState {
  switch (action.type) {
    case TaskAssignmentActionType.TASK_ASSIGNMENT_LIST_REQUEST:
      return {
        ...state,
        criteriaObject: action.payload
      };
    case TaskAssignmentActionType.TASK_ASSIGNMENT_LIST_RESPONSE:
      return adapter.setAll(action.payload.content, {
        ...state,
        criteriaObject: {
          ...state.criteriaObject,
          page: action.payload.page,
          size: action.payload.size
        },
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages
      });
    case TaskAssignmentActionType.TASK_ASSIGNMENT_GET_BY_ID_RESPONSE:
      return {
        ...state,
        selected: action.payload
      };

    case TaskAssignmentActionType.TASK_ASSIGNMENT_GET_BY_ID_RESET:
      return {
        ...state,
        selected: null
      };
    default: {
      return state;
    }
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
